import "./Footer.css";
import links from "../config/links";

function Footer() {
  return (
    <footer className="footer">
      <h2>Connect with Us</h2>
      <div className="main-outer">
        <div className="main">
          <div className="footer-section">
            <div>
              <a href={`mailto:${links.external.email}`}>
                <img
                  src="/footer_logos/email_logo.svg"
                  alt="mail_logo"
                  width="40px"
                  style={{ filter: "invert(1)" }}
                ></img>
                <p>Email</p>
              </a>
            </div>
            <div>
              <a href={links.external.discord}>
                <img
                  src="/footer_logos/discord_logo.svg"
                  alt="discord_logo"
                  width="40px"
                  style={{ filter: "invert(1)" }}
                ></img>
                <p>Discord</p>
              </a>
            </div>
          </div>
          <div className="footer-section">
            <div>
              <a href={links.external.linktree}>
                <img
                  src="/linktree_white.svg"
                  alt="contact_logo"
                  width="35px"
                  style={{ marginRight: "13px" }}
                ></img>
                <p>LinkTree</p>
              </a>
            </div>
            <div>
              <a href={links.external.instagram}>
                <img
                  src="/footer_logos/insta_logo.svg"
                  alt="insta_logo"
                  width="40px"
                  style={{ filter: "invert(1)" }}
                ></img>
                <p>Instagram</p>
              </a>
            </div>
          </div>
        </div>
        <div className="footer-section">
          <p>Special Thanks to Our Sponsors</p>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <a href={links.external.fanfan}>
              <img src="/footer_logos/fanfan.png" alt="Sponsor 1" />
            </a>
            <a href={links.external.monoceros}>
              <img src="/footer_logos/monoceros1.png" alt="Sponsor 2" />
            </a>
          </div>
        </div>
      </div>

      <p>© 2026 UBIC at UCSD. All Rights Reserved</p>
    </footer>
  );
}

export default Footer;
